import { render, staticRenderFns } from "./ModalNuevaAccion.vue?vue&type=template&id=c8c1a79a"
import script from "./ModalNuevaAccion.vue?vue&type=script&lang=js"
export * from "./ModalNuevaAccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8c1a79a')) {
      api.createRecord('c8c1a79a', component.options)
    } else {
      api.reload('c8c1a79a', component.options)
    }
    module.hot.accept("./ModalNuevaAccion.vue?vue&type=template&id=c8c1a79a", function () {
      api.rerender('c8c1a79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/ModalNuevaAccion.vue"
export default component.exports